import React from 'react';
import IMG1 from '../../assets/reactEcommerce.png';
import IMG2 from '../../assets/AdvanceEcommerce.png';
import IMG3 from '../../assets/super_market_ana.png';
import IMG4 from '../../assets/reactdjangnoFullstack.png';
import IMG5 from '../../assets/house_price_pridiction.png';
import IMG6 from '../../assets/laptop_price.png';
import IMG7 from '../../assets/kaggle_api_data.png'
import IMG8 from '../../assets/loan_data.png'
import IMG9 from '../../assets/market.png'
import IMG10 from '../../assets/google_django_signup.png'
import IMG11 from '../../assets/chatbot.png'
import IMG12 from '../../assets/webscraping_bs4.png'
import IMG13 from '../../assets/casinoze.png'
import IMG14 from '../../assets/screenshot1.jpg'
import IMG15 from '../../assets/ai-assitant.jpg'
import IMG16 from '../../assets/ai-save-respose-of-chat.jpg'
import IMG17 from '../../assets/abkareem.png'
import IMG18 from '../../assets/kashayousef.png'
import IMG19 from '../../assets/pakwatchhub.png'
import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [

    {
      id: 1,
      title: 'Full-Stack Gaming Platform',
      img: IMG13,
      description: 'Developed a real-time multiplayer gaming platform using Django REST Framework, WebSockets, and custom middlewares. Implemented responsive UI with Tailwind CSS, JSS, CSS, and HTML5.',
      technologies: 'DRF | WebSockets | Tailwind CSS | JSS ',
      link: 'https://casinoze.com/',
      github: 'https://github.com/Ammad-123/Django',
    },
    {
      id: 14,
      title: 'Enterprise RAG Agent for PDF Knowledge Systems',
      img: IMG14,
      description:
        'Engineered a Retrieval-Augmented Generation (RAG) system to process PDFs (sales reports, catalogs, policies) and deliver context-aware, precise responses.',
      technologies: 'Python, FastAPI, LangChain, LangGraph',
      link: 'https://www.youtube.com/watch?v=9wEkG5kH9FE&t=136s&ab_channel=CodeWithHafiz',
      github: 'https://github.com/Ammad-123',
    },
    {
      id: 15,
      title: 'Built an AI Assistant',
      img: IMG15,
      description:
        'Built an AI Assistant That Writes, Saves & Sends Emails Using Just Natural Language | LangGraph',
      technologies: 'Python | LangGraph | LangChain | ChromaDB | Hugging Face |NLP | Grok',
      link: 'https://www.youtube.com/watch?v=RUJXhLgCcec&list=PLG0uGkriidmtkmXZEXdsGon_1ZfI6HW-s&ab_channel=CodeWithHafiz',
      github: 'https://github.com/Ammad-123',
    },
    {
      id: 16,
      title: 'End to End AI Memory Bank – Save Every Brilliant Response using Python',
      img: IMG16,
      description:
        'This sleek Python logger automatically preserves your most valuable conversations with cutting-edge AI models.',
      technologies: 'LangChain | ChromaDB | Hugging Face',
      link: 'https://www.youtube.com/watch?v=9wEkG5kH9FE&list=PLG0uGkriidmtkmXZEXdsGon_1ZfI6HW-s&index=2&ab_channel=CodeWithHafiz',
      github: 'https://github.com/Ammad-123',
    },
    {
      id: 17,
      title: 'ABKareem Solutions – AI & Digital Agency Website',
      img: IMG17,
      description:
        'A modern, high-conversion digital agency website built with ReactJS to showcase AI solutions, automation services, and enterprise-grade software offerings.',
      technologies:
        'ReactJS | JavaScript | Modern CSS ',
      link: 'https://abkareemsolutions.netlify.app/',
    },
    {
      id: 18,
      title: 'Personal Portfolio & Consulting Website',
      img: IMG18,
      description:
        'A premium personal portfolio and consulting website built to showcase professional experience, drive client engagement, and support global hiring.',
      technologies:
        'ReactJS | JavaScript | Modern CSS | Responsive Design | UI/UX',
      link: 'https://kashyousaf.netlify.app',
    },
    {
      id: 19,
      title: 'PakWatchHub – News & Media Web Platform',
      img: IMG19,
      description:
        'A modern news and media platform built with ReactJS, focused on content organization, readability, and responsive design.',
      technologies:
        'ReactJS | JavaScript | CSS | Responsive Design | UI/UX',
      link: 'https://pakwatchhub.netlify.app/',
    },
    {
      id: 4,
      title: 'E-Commerce Website ',
      img: IMG1,
      description:
        'E-Commerce Website with Search and Advance Filtering System with React',
      technologies: 'ReactJs',
      link: 'https://www.youtube.com/watch?v=fo4X9Fxnbz8/',
      github: 'https://github.com/Ammad-123',
    },
    {
      id: 2,
      title: 'FullStack CRUD app using Django and Reactjs',
      img: IMG4,
      description:
        'FullStack CRUD app using Django and Reactjs',
      technologies: 'React | Django',
      link: 'https://youtube.com/watch?v=OvFoZIur9AU',
      github: 'https://github.com/Ammad-123/Django',
    },
    {
      id: 3,
      title: 'Advance Django Ecommerce Website',
      img: IMG2,
      description: 'Advance Django Ecommerce Website with Email, Authentication and Payment Integration',
      technologies: 'JavaScript | Django',
      link: 'https://youtube.com/watch?v=0pU3_Ivw0ZI&t=119s',
      github: 'https://github.com/Ammad-123/Django',
    },
    {
      id: 13,
      title: 'Super Market Data Analysis',
      img: IMG3,
      description:
        'This project analyzes supermarket data with Pandas, NumPy, Matplotlib, and Seaborn to enhance decision-making, customer satisfaction, and inventory management.',
      technologies: 'Pandas | Numpy | Seaborn | matplotlib',

      link: 'https://www.youtube.com/watch?v=cl3Z1qFCquQ',
      github: 'https://github.com/Ammad-123',
    },
    {
      id: 10,
      title: 'Social login using Django and Google',
      img: IMG10,
      description:
        'Django login system using Google authentication',
      technologies: 'Python | Django | Google | HTML | CSS',

      link: 'https://www.youtube.com/watch?v=qmVVDtMmE64',
      github: 'https://github.com/Ammad-123/Django',
    },
    {
      id: 11,
      title: 'Integrating Rasa for Intelligent Conversations with Flask',
      img: IMG11,
      description: 'This tutorial walks you through connecting Flask with Rasa\'s conversational AI capabilities.',
      technologies: 'Python | Flask | Rasa | REST API | HTML',

      link: 'https://www.youtube.com/watch?v=yRF4i9oHGJs',
      github: 'https://github.com/Ammad-123/Flask',
    },
    {
      id: 12,
      title: 'Extracting and Organizing Job Listings',
      img: IMG12,
      description:
        "I developed a complete web scraping solution using Python and BeautifulSoup to extract job listings from TimesJobs, filtering based on specific skills and organizing the data into structured files.",
      technologies: 'BeautifulSoup | Requests| Web Scraping',

      link: 'https://www.youtube.com/watch?v=i7tgdIJ6GKY',
      github: 'https://github.com/Ammad-123/WebScraping',
    },
    {
      id: 9,
      title: 'Flask Market project with Authentications',
      img: IMG9,
      description:
        'Flask market project using sqlite for db and password hashing with registration and login',
      technologies: 'Python | Flask | Sqlite | HTML | CSS',

      link: 'https://www.youtube.com/watch?v=euYmEA5IH_o',
      github: 'https://github.com/Ammad-123/flask',
    },
    {
      id: 5,
      title: 'House Price Prediction | Machine Learning Model',
      img: IMG5,
      description:
        'A full machine learning project and we go through the full data science process, to predict housing prices in Python.',
      technologies: 'Pandas | Numpy | Seaborn | matplotlib | Scikit-learn',
      link: 'https://www.youtube.com/watch?v=VG7calDxywE&t=22s/',
      github: 'https://github.com/Ammad-123/',
    },
    {
      id: 6,
      title: 'Laptop Price Prediction | Machine Learning Model',
      img: IMG6,
      description:
        'A full machine learning project and we go through the full data science process, to predict laptop prices in Python.',
      technologies: 'Python | Databricks | Pyspark',
      link: 'https://www.youtube.com/watch?v=RVvBbyT9Tx4',
      github: 'https://github.com/Ammad-123/',
    },
    {
      id: 7,
      title: 'End to End data Analytics project using Python and SQL with Kaggle API',
      img: IMG7,
      description:
        'Data-Driven Insights: Leveraged Python and SQL to conduct a comprehensive data analysis project using Kaggle datasets.',
      technologies: 'Python | SQL | Kaggle API | Pandas ',
      link: 'https://www.youtube.com/watch?v=kqPcAONa1DE',
      github: 'https://github.com/Ammad-123/',
    },
    {
      id: 8,
      title: 'Loan Data Set Analysis Databricks and PySpark ',
      img: IMG8,
      description:
        'Understand the power of Databricks as a cloud-based data analytics platform and the benefits of using PySpark for scalable data processing.',
      technologies: 'Python | SQL | Kaggle API | Pandas ',
      link: 'https://www.youtube.com/watch?v=0M528wi7rLw',
      github: 'https://github.com/Ammad-123/',
    },

  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
